"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setProgressBarCurrentStep = exports.setCurrentStep = exports.initializeProgressBar = void 0;
const initializeProgressBar = (steps) => ({
    type: 'INITIALIZE_PROGRESS_BAR',
    steps,
});
exports.initializeProgressBar = initializeProgressBar;
const setCurrentStep = (index) => ({
    type: 'SET_CURRENT_STEP',
    index,
});
exports.setCurrentStep = setCurrentStep;
const setProgressBarCurrentStep = (label) => ({
    type: 'SET_PROGRESS_BAR_CURRENT_STEP',
    label,
});
exports.setProgressBarCurrentStep = setProgressBarCurrentStep;
